"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _resource_decrypter = require("./resource_decrypter");

var _resource_decrypter2 = _interopRequireDefault(_resource_decrypter);

var _zlibjs = require("zlibjs");

var _zlibjs2 = _interopRequireDefault(_zlibjs);

var _pngjs = require("pngjs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Much of the logic around SWF asset extraction is based on the file format specification at
// http://wwwimages.adobe.com/content/dam/Adobe/en/devnet/swf/pdf/swf-file-format-spec.pdf
var SWF_TAG_END = 0;
var SWF_TAG_SET_BACKGROUND_COLOR = 9;
var SWF_TAG_DEFINE_SOUND = 14;
var SWF_TAG_DEFINE_BITS_JPEG_2 = 21;
var SWF_TAG_PROTECT = 24;
var SWF_TAG_DEFINE_BITS_LOSSLESS_2 = 36;
var SWF_TAG_FRAME_LABEL = 43;
var SWF_TAG_EXPORT_ASSETS = 56;
var SWF_TAG_IMPORT_ASSETS = 57;
var SWF_TAG_ENABLE_DEBUGGER = 58;
var SWF_TAG_ENABLE_DEBUGGER_2 = 64;
var SWF_TAG_SCRIPT_LIMITS = 65;
var SWF_TAG_SET_TAB_INDEX = 66;
var SWF_TAG_FILE_ATTRIBUTES = 69;
var SWF_TAG_IMPORT_ASSETS_2 = 71;
var SWF_TAG_SYMBOL_CLASS = 76;
var SWF_TAG_METADATA = 77;
var SWF_TAG_DEFINE_SCALING_GRID = 78;
var SWF_TAG_DEFINE_SCENE_AND_FRAME_LABEL_DATA = 86;
var SWF_TAG_DEFINE_BINARY_DATA = 87;

// Complete list as of SWF 10
var SWF_AUDIO_FORMAT_UNCOMPRESSED_BIG = 0;
var SWF_AUDIO_FORMAT_ADPCM = 1;
var SWF_AUDIO_FORMAT_MP3 = 2;
var SWF_AUDIO_FORMAT_UNCOMPRESSED_LITTLE = 3;
var SWF_AUDIO_FORMAT_NELLYMOSER_16 = 4;
var SWF_AUDIO_FORMAT_NELLYMOSER_8 = 5;
var SWF_AUDIO_FORMAT_NELLYMOSER = 6;
var SWF_AUDIO_FORMAT_SPEEX = 11;

function getResourceUrl(basePath, resourceId) {
  return basePath + "/data/" + resourceId.substr(0, 2) + "/" + resourceId.substr(2, 1) + "/" + resourceId;
}

function getBlobFromAsset(swfBytes, assetDataStart, assetDataLength, blobType) {
  return new Blob([new Uint8Array(swfBytes.buffer, assetDataStart, assetDataLength)], blobType == null ? {} : { type: blobType });
}

function arraysAreEqual(a, b) {
  if (a == null && b != null || a != null && b == null || a.length != b.length) {
    return false;
  } else {
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
  }
  return true;
}

function buildPngFromBitmapArray(width, height, bitmapData) {
  var png = new _pngjs.PNG({
    width: width,
    height: height
  });
  var pos = 0;
  for (var pixel = 0; pixel < width * height; pixel++) {
    var alpha = bitmapData[pos],
        red = bitmapData[pos + 1],
        green = bitmapData[pos + 2],
        blue = bitmapData[pos + 3];
    png.data[pos++] = red;
    png.data[pos++] = green;
    png.data[pos++] = blue;
    png.data[pos++] = alpha;
  }
  return _pngjs.PNG.sync.write(png);
}

function retrieveResourceFromSwf(swfBytes) {
  var uncompressedData;
  try {
    // Validate that we're dealing with a SWF file
    if (swfBytes.length < 8) {
      console.log("File is not large enough to be a SWF file");
      return null;
    }
    if (swfBytes[0] != 0x43 && swfBytes[0] != 0x46 || swfBytes[1] != 0x57 || swfBytes[2] != 0x53) {
      console.log("First three bytes didn't match expected SWF signature of CWS or FWS");
      return null;
    }
    // If the first byte is C, the rest of the file after the initial 8 bit header is Zlib compressed
    if (swfBytes[0] == 0x43) {
      // var inflate = new Zlib.Inflate(swfBytes, {'index' : 8});
      uncompressedData = _zlibjs2.default.inflateSync(Buffer.from(swfBytes.buffer, 8));
    } else {
      uncompressedData = swfBytes.subarray(8);
    }
    if (uncompressedData == null || uncompressedData.length == 0) {
      console.log("No data found or failed to uncompress");
      return null;
    }
    var indexInData = 0;
    var bitsPerField = uncompressedData[indexInData] >> 3;
    // Skip over the file header
    indexInData += (bitsPerField * 4 + // xywh
    5 + // length bits
    7) / // to round up
    8 + // bits -> bytes
    4; // Don't care about frame rate or frame count

    while (indexInData < uncompressedData.length) {
      var tagCodeAndLength = uncompressedData[indexInData++] | uncompressedData[indexInData++] << 8,
          tagCode = tagCodeAndLength >> 6,
          tagLength = tagCodeAndLength & 0x3F;

      if (tagLength == 0x3F) {
        tagLength = uncompressedData[indexInData++] | uncompressedData[indexInData++] << 8 | uncompressedData[indexInData++] << 16 | uncompressedData[indexInData++] << 24;
      }

      switch (tagCode) {
        case SWF_TAG_DEFINE_SOUND:
          // Skip sound ID
          indexInData += 2;
          var soundFormat = uncompressedData[indexInData++];
          if (soundFormat >> 4 != SWF_AUDIO_FORMAT_MP3) {
            // Skip this sound, we only care about MP3s
            indexInData += tagLength - 3;
            break;
          }
          // Skip sample count
          indexInData += 4;
          return getBlobFromAsset(uncompressedData, indexInData, tagLength - 7, 'audio/mpeg');
        case SWF_TAG_DEFINE_BINARY_DATA:
          // Skip character ID and reserved field
          indexInData += 6;
          return getBlobFromAsset(uncompressedData, indexInData, tagLength - 6, 'text/*');
        case SWF_TAG_DEFINE_BITS_JPEG_2:
          // Skip character ID
          indexInData += 2;
          // Check the image type
          if (arraysAreEqual(uncompressedData.subarray(indexInData, indexInData + 8), [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A])) {
            return getBlobFromAsset(uncompressedData, indexInData, tagLength - 2, 'image/png');
          } else if (arraysAreEqual(uncompressedData.subarray(indexInData, indexInData + 6), [0x47, 0x49, 0x46, 0x38, 0x39, 0x61])) {
            return getBlobFromAsset(uncompressedData, indexInData, tagLength - 2, 'image/gif');
          } else {
            return getBlobFromAsset(uncompressedData, indexInData, tagLength - 2, 'image/jpeg');
          }
        case SWF_TAG_DEFINE_BITS_LOSSLESS_2:
          indexInData += 2;
          var bitmapFormat = uncompressedData[indexInData++];
          if (bitmapFormat != 5) {
            console.log("Tried to load tag BITS_LOSSLESS_2 with unsupported format");
            return null;
          }
          var bitmapWidth = uncompressedData[indexInData++] | uncompressedData[indexInData++] << 8;
          var bitmapHeight = uncompressedData[indexInData++] | uncompressedData[indexInData++] << 8;
          var compressedBitmapData = new Uint8Array(uncompressedData.buffer, indexInData, tagLength - 7);
          var bitmapData = _zlibjs2.default.inflateSync(Buffer.from(compressedBitmapData));
          var pngImage = buildPngFromBitmapArray(bitmapWidth, bitmapHeight, bitmapData);
          return getBlobFromAsset(pngImage, 0, pngImage.length, 'image/png');
        case SWF_TAG_END:
          indexInData = uncompressedData.length;
          break;
        default:
          indexInData += tagLength;
          break;
      }
    }
  } catch (e) {
    if (e instanceof RangeError) {
      console.log("Unexpected end of file: " + e);
    } else {
      console.log("Error parsing SWF file: " + e);
    }
  }
  return null;
}

function stripTrailingSlash(path) {
  return path.replace(/\/$/, "");
}

var ResourceManager = function () {
  function ResourceManager(decryptionKeys, puddleBasePath, alternatePuddleBasePath, alternatePuddleBasePathServesPermutedFiles) {
    _classCallCheck(this, ResourceManager);

    this.decryptionKeys = decryptionKeys;
    this.puddleBasePath = stripTrailingSlash(puddleBasePath);
    this.alternatePuddleBasePath = stripTrailingSlash(alternatePuddleBasePath);
    this.alternatePuddleBasePathServesPermutedFiles = alternatePuddleBasePathServesPermutedFiles || false;
    this.resourceDecrypter = new _resource_decrypter2.default();
  }

  _createClass(ResourceManager, [{
    key: "loadResource",
    value: function loadResource(resourceId) {
      var self = this;
      return new Promise(function (resolve, reject) {
        fetch(getResourceUrl(self.puddleBasePath, resourceId)).then(function (response) {
          if (response.ok) {
            return response.blob();
          } else {
            return null;
          }
        }, reject).then(function (resourceBlob) {
          if (resourceBlob == null) {
            reject();
            return;
          }
          var reader = new FileReader();
          reader.addEventListener("loadend", function () {
            var resourceBytes = new Uint8Array(this.result);
            self.resourceDecrypter.decrypt(resourceBytes, resourceId, self.decryptionKeys);
            var resourceAsset = retrieveResourceFromSwf(resourceBytes);
            if (resourceAsset == null) {
              reject();
            } else {
              resolve(resourceAsset);
            }
          });
          reader.addEventListener("error", function () {
            reject();
          });
          reader.readAsArrayBuffer(resourceBlob);
        }, reject);
      });
    }
  }]);

  return ResourceManager;
}();

exports.default = ResourceManager;


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/@rosetta+resource-manager@file+@rosetta+resource-manager/~/@rosetta/resource-manager/dist/resource_manager.js
// module id = 325
// module chunks = 0